const colors = {
    white: "#FFFFFF",
    darkBlue: "#213F7D",
    green: "#39CDCC",
    grey: "#545F7D",
    lightGrey: "#FAFAFA",
    blue02: "#213F7D",
    yellow: "#E9B200",
    buttonRed: "#E4033B",
    redError: "#EB5757",
};

export { colors };